import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ValidatorPatterns } from '@shared/validatorpatterns';
import { IBatchStatus, IPostBatchRequest, MesBatchService } from '../mes-batch-service';

@Component({
	selector: 'app-create-batch',
	templateUrl: './create-batch.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateBatchComponent implements OnInit {
	@Output() created: EventEmitter<any> = new EventEmitter();
	form: FormGroup;
	loading: boolean = false;
	httpError: string = '';

	statuses = Object.keys(IBatchStatus).filter((key) => Number.isNaN(Number(IBatchStatus[key])));

	item: IPostBatchRequest = {
		alias: null,
		name: null,
		status: IBatchStatus.Draft,
		errors: null,
	};

	constructor(
		public dialogRef: MatDialogRef<CreateBatchComponent>,
		private service: MesBatchService,
		private fb: FormBuilder,
	) {}

	ngOnInit(): void {
		this.initializeForm();
	}

	initializeForm(): void {
		this.form = this.fb.group({
			alias: [this.item.alias, [Validators.required, Validators.maxLength(255), Validators.pattern(ValidatorPatterns.Alias)]],
			name: [this.item.name, [Validators.maxLength(255), Validators.pattern(ValidatorPatterns.Alias)]],
			status: this.item.status,
		});
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.item) {
					this.item[key] = value[key];
				}
			});
		});
	}

	get controls() {
		return this.form.controls;
	}

	onCancel = () => this.dialogRef.close();

	onSave() {
		if (this.loading) return;
		this.httpError = '';
		if (this.form.valid) {
			this.loading = true;
			this.service.create(this.item).subscribe({
				next: () => {
					this.created.emit();
					this.dialogRef.close();
				},
				error: (errorResponse) => {
					this.httpError = `${errorResponse.status}`;
					this.loading = false;
				},
			});
		}
	}
}
